export const ensUri = process.env.REACT_APP_MARKETPLACE_SUBGRAPH;
export const marketUri = process.env.REACT_APP_DOMAIN_SUBGRAPH;

// Smart contract addresses
export const REGISTRAR_CONTRACT_ADDRESS = "0x22f17bd536706f9a7614e792c769247c74945b71";